import { render, staticRenderFns } from "./JsonSchema.vue?vue&type=template&id=7b47fe4b"
import script from "./JsonSchema.vue?vue&type=script&lang=js"
export * from "./JsonSchema.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./JsonSchema.vue?vue&type=style&index=0&id=7b47fe4b&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports